<script lang="ts">
  import { enhance } from '$app/forms';
  import { FormStatus } from '$lib/form';
  import type { SubmitFunction } from '@sveltejs/kit';

  const status = new FormStatus();
  export let action: string | undefined = undefined;
  export let submit: SubmitFunction | undefined = undefined;

  const customSubmit: SubmitFunction = (input) => {
    status.start();
    const handlerPromise = submit?.({
      ...input,
      cancel: () => {
        status.finish(false);
        input.cancel();
      }
    });

    return async (response) => {
      if (handlerPromise !== undefined) {
        const handler = await handlerPromise;
        if (handler !== undefined) {
          handler(response);
        }
      }
      status.finish(response.result.type === 'success' || response.result.type === 'redirect');
    };
  };
</script>

<form {action} method="POST" use:enhance={customSubmit} enctype="multipart/form-data">
  <slot {status} />
</form>
